/**
 * @deprecated - This module is no longer in use.
 *
 * @file index.tsx
 * @module all-products/index
 * @description The index module for all-products routes.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026. Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.1.9
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
// import AllProducts from "./products/all-products-finance";
import AllProducts from './all-products';
import ProductDetails from './product-details';
import EditStockCount from './../products/product-details-tabs/edit-stock-count';
import DiscountedProducts from './products/discounted-products';
import SellerProfile from '../seller/seller-profile/seller-profile';
const allProductsBreadCrumbs: Array<PageLink> = [
  {
    title: 'All Products',
    path: '/all-products',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        {/* <Route index element={<Navigate to="/add-seller/add" />} /> */}
        <Route
          index
          element={
            <>
              <PageTitle>
                All Products
              </PageTitle>
              <AllProducts />
            </>
          }
        />
        {/* <Route
          path="products/all-products"
          element={
            <>
              <AllProducts />
            </>
          }
        /> */}
        <Route
          path="seller-profile"
          element={
            <>
              <PageTitle breadcrumbs={allProductsBreadCrumbs}>
                Seller Profile
              </PageTitle>
              <SellerProfile />
            </>
          }
        />
        <Route
          path="discounted-products"
          element={
            <>
              <PageTitle breadcrumbs={allProductsBreadCrumbs}>
                Discounted Products
              </PageTitle>
              <DiscountedProducts />
            </>
          }
        />
        <Route
          path="product-details"
          element={
            <>
              <PageTitle breadcrumbs={allProductsBreadCrumbs}>
                Product Details
              </PageTitle>
              <ProductDetails />
            </>
          }
        />
        <Route
          path="edit-stock-count"
          element={
            <>
              <PageTitle breadcrumbs={allProductsBreadCrumbs}>
                Edit Stock Count
              </PageTitle>
              <EditStockCount />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default index;
